import { Col, Row, Typography } from 'antd';

import Loading from '../../Pages/purchase-request/Loading';

const { Text } = Typography;

/**
 * @component
 * @param {Object} props - Component props
 * @param {Array} props.items - Array of items
 * @param {string} props.items[].key - Unique key for the item
 * @param {string} props.items[].title - Title of the item
 * @param {React.Element} props.items[].input - React element for input
 * @param {boolean} props.items[].required - Whether the input is required
 * @param {number} props.items[].colSpan - Column span for layout
 * @param {boolean} props.loading - Loading state
 * @returns {JSX.Element} Renders key-value pairs to be used in a modal
 */

const ModalKeyValuePair = ({ items, loading = false }) => {
  if (loading) return <Loading />;
  return (
    <div className="flex-vertical gap-10">
      {items.map((ele) => (
        <Row key={ele.key} gutter={8}>
          <Col span={8}>
            <Text className={ele.required ? 'required-after' : ''}>{`${ele.title}${ele.title ? ':' : ''}`}</Text>
          </Col>
          <Col span={ele?.colSpan ?? 16}>{ele.input}</Col>
        </Row>
      ))}
    </div>
  );
};

export default ModalKeyValuePair;
